// Continues a Markdown numbered list ("1. ", "2) ") when a newline is typed
// at the end of a list item. A newline on an empty item ends the list.
const LIST_ITEM = /^(\s*)(\d{1,6})([.)]) (.*)$/

export type NumberedListInput = {
  previousValue: string
  nextValue: string
  selectionStart: number
  selectionEnd: number
  inputType: string | null
}

export type NumberedListResult = {
  value: string
  caret: number
  changed: boolean
}

export function continueNumberedList(input: NumberedListInput): NumberedListResult {
  const { previousValue, nextValue, selectionStart, selectionEnd, inputType } = input
  const unchanged = { value: nextValue, caret: selectionEnd, changed: false }
  if (inputType === 'insertFromPaste' || inputType === 'insertFromDrop') return unchanged
  if (selectionStart !== selectionEnd) return unchanged
  if (nextValue.length !== previousValue.length + 1) return unchanged
  const caret = selectionEnd
  // Exactly one newline was inserted immediately before the caret.
  if (caret < 1 || nextValue[caret - 1] !== '\n') return unchanged
  if (nextValue.slice(0, caret - 1) + nextValue.slice(caret) !== previousValue) return unchanged

  const lineStart = nextValue.lastIndexOf('\n', caret - 2) + 1
  const line = nextValue.slice(lineStart, caret - 1)
  const match = LIST_ITEM.exec(line)
  if (!match) return unchanged
  const [, indent, number, delimiter, content] = match

  if (!content.trim()) {
    // Enter on an empty item ends the list: drop the marker and the newline.
    const value = nextValue.slice(0, lineStart) + nextValue.slice(caret)
    return { value, caret: lineStart, changed: true }
  }

  const marker = `${indent}${Number(number) + 1}${delimiter} `
  const value = nextValue.slice(0, caret) + marker + nextValue.slice(caret)
  return { value, caret: caret + marker.length, changed: true }
}
